export function getdata() {
	var obj = {
		
			headDatasvii:[
					{
						title: "实际缴纳企业所得税计算",
						prop: "groud",
						width: "55px",
					},
					{
						title: "",
						prop: "text1",
						custom: true,
						width: "100px",
					},
					{
						title: "",
						prop: "text2",
						custom: true,
						width: "100px",
					},
					{
						title: "",
						prop: "text3",
						custom: true,
					},
					{
						title: "",
						width:"100px",
						prop: "sdsA_1_x_3",
						custom: true,
					},
			],
			tableDatasvii:[
				{
					groud: "FZ1",
					text1: "中央级收入实际应纳税额[本期:32行x60%或(34行+35行+36行)x60%或38行x60%]",
					text2: "",
					text3: "",
					disabledsdsA_1_x_3:false,
					sdsA_1_x_3: {
						cellCode: "sdsA_1_38.1_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				{
					groud: "FZ2",
					text1: "中央待分配收入应纳税额[本期:(34行+35行)x20%]",
					text2: "",
					text3: "",
					disabledsdsA_1_x_3:false,
					sdsA_1_x_3: {
						cellCode: "sdsA_1_38.2_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				{
					groud: "FZ3",
					text1: "地方级收入应纳税额[本期:32行x40%或(34行+35行)x20%+36行*40%或(34行+35行+36行)x40%或38行x40%]",
					text2: "",
					text3: "",
					disabledsdsA_1_x_3:false,
					sdsA_1_x_3: {
						cellCode: "sdsA_1_38.3_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				{
					groud: "39",
					text1: "减：民族自治地区企业所得税地方分享部分",
					text2: "",
					text3: "本期实际减免金额",
					disabledsdsA_1_x_3:false,
					sdsA_1_x_3: {
						cellCode: "sdsA_1_39_3",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				{
					groud: "39.1",
					text1: "",
					text2: "",
					text3: "本机构本年累计金额",
					disabledsdsA_1_x_3:false,
					sdsA_1_x_3: {
						cellCode: "sdsA_1_39.1_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				{
					groud: "39.2",
					text1: "",
					text2: "",
					text3: "本年累计应减免金额",
					disabledsdsA_1_x_3:false,
					sdsA_1_x_3: {
						cellCode: "sdsA_1_39.2_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				{
					groud: "FZ4",
					text1: "地方级收入实际应纳税额(本期:FZ3-39)",
					text2: "",
					text3: "",
					disabledsdsA_1_x_3:false,
					sdsA_1_x_3: {
						cellCode: "sdsA_1_39.3_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				{
					groud: "40",
					text1: "实际应补（退）所得税额",
					text2: "",
					text3: "",
					disabledsdsA_1_x_3:false,
					sdsA_1_x_3: {
						cellCode: "sdsA_1_40_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
			],
			headDatasvi:[
					{
					title: "汇总纳税企业总分机构税款计算",
					prop: "groud",
					width: "100px",
				},{
					title: "",
					prop: "text",
					width: "100px",
					custom: true,
				},{
					title: "",
					prop: "title",
					 width:'400px',
					align:"left",
					custom: true,
				},{
					title: "",
					prop: "sdsA_1_x_3",
					width: "200px",
					custom: true,
				},
			],
			
			tableDatasvi:[
				{
					groud:'33',
					text:'总机构',
					title:'总机构本期分摊应补（退）所得税额（34+35+36）',
					disabledsdsA_1_x_3:true,
					sdsA_1_x_3: {
						cellCode:"sdsA_1_33_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'34',
					text:'总机构',
					title:'其中：总机构分摊应补（退）所得税额（填写A202000表）' ,
					disabledsdsA_1_x_3:true,
					sdsA_1_x_3: {
						cellCode:"sdsA_1_34_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'35',
					text:'总机构',
					title:'财政集中分配应补（退）所得税额（填写A202000表）',
					disabledsdsA_1_x_3:true,
					sdsA_1_x_3: {
						cellCode:"sdsA_1_35_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'36',
					text:'总机构',
					title:'总机构主体生产经营部门分摊应补（退）所得税额（填写A202000表）',
					disabledsdsA_1_x_3:true,
					sdsA_1_x_3: {
						cellCode:"sdsA_1_36_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'37',
					text:'分支机构填报',
					title:'分支机构本期分摊比例',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_3: {
						cellCode:"sdsA_1_37_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'38',
					text:'分支机构填报',
					title:'分支机构本期分摊应补（退）所得税额',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_3: {
						cellCode:"sdsA_1_38_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
			],
			headDatasv:[{
				title: "预缴税款计算",
				children:[
				
				{
					title: "行次",
					prop: "hanh",
					width:'100px',
				},{
					title: "项目",
					prop: "title",
					custom: true,
				
				width:'450px',
				},{
					title: "本年累计金额",
					prop: "sdsA_1_x_2",
					custom: true,
				
				width:'200px',
				},
				]
			}],
			tableDatasv:[
				{
					groud:'1',
					title:'营业收入',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_1_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'1.1',
					title:'其中：自营出口收入',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_1.1_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'1.2',
					title:'委托出口收入',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_1.2_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'1.3',
					title:'出口代理费收入',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_1.3_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'2',
					title:'减：营业成本',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_2_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'3',
					title:'减：税金及附加',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_3_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'4',
					title:'减：销售费用',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_4_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'5',
					title:'减：管理费用',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_5_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'6',
					title:'减：研发费用',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_6_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'7',
					title:'减：财务费用',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_7_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'8',
					title:'加：其他收益',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_8_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'9',
					title:'加：投资收益（9.1+9.2）（损失以“－”号填列）',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_9_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'9.1',
					title:'其中:股权投资确认的处置收益',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_9.1_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'9.2',
					title:'其他投资收益',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_9.2_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'10',
					title:'加：净敞口套期收益（损失以“－”号填列）',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_10_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'11',
					title:'加：公允价值变动收益（损失以“－”号填列）',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_11_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'12',
					title:'加：信用减值损失（损失以“－”号填列）',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_12_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'13',
					title:'加：资产减值损失（损失以“－”号填列）',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_13_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'14',
					title:'加：资产处置收益（损失以“－”号填列）',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_14_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'15',
					title:'营业利润（亏损以“－”号填列）',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_15_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'16',
					title:'加：营业外收入',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_16_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'17',
					title:'减：营业外支出',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_17_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'18',
					title:'利润总额（15+16-17）',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_18_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'19',
					title:'加：特定业务计算的应纳税所得额',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_19_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'19.1',
					title:'其中：销售未完工产品的收入',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_19.1_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'20',
					title:'减：不征税收入',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_20_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'21',
					title:'减：资产加速折旧、摊销（扣除）调减额（填写A201020）',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_21_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'22',
					title:'减：免税收入、减计收入、加计扣除（22.1+22.2+…）',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_22_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'22.1',
					title:'（填写优惠事项名称）',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_1: {
						cellCode:"sdsA_1_22.1_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_2: {
						cellCode:"sdsA_1_22.1_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'22.2',
					title:'（填写优惠事项名称）',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_1: {
						cellCode:"sdsA_1_22.2_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_2: {
						cellCode:"sdsA_1_22.2_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'23',
					title:'减：所得减免（23.1+23.2+……）',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_23_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'23.1',
					title:'（填写优惠事项名称）',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_1: {
						cellCode:"sdsA_1_23.1_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_2: {
						cellCode:"sdsA_1_23.1_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'23.2',
					title:'（填写优惠事项名称）',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_1: {
						cellCode:"sdsA_1_23.2_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_2: {
						cellCode:"sdsA_1_23.2_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'24',
					title:'减：弥补以前年度亏损',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_24_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'25',
					title:'实际利润额（18+19-20-21-22-23-24）\\ 按照上一纳税年度应纳税所得额平均额确定的应纳税所得额',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_25_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'26',
					title:'税率(25%)',
					disabledsdsA_1_x_2:true,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_26_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'27',
					title:'应纳所得税额（25×26）',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_27_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'28',
					title:'减：减免所得税额（28.1+28.2+……）',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_28_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'28.1',
					title:'（填写优惠事项及代码）',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_1: {
						cellCode:"sdsA_1_28.1_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_2: {
						cellCode:"sdsA_1_28.1_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'28.2',
					title:'（填写优惠事项及代码）',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_1: {
						cellCode:"sdsA_1_28.2_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_2: {
						cellCode:"sdsA_1_28.2_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'29',
					title:'减：抵免所得税额',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_29_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'29.1',
					title:'其中：本年允许抵免专用设备投资额（填写专用设备投资类型）',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_29.1_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'29.2',
					title:'本年允许抵免专用设备投资额（填写专用设备投资类型）',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_29.2_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'30',
					title:'减：本年累计已预缴所得税额',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_30_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'31',
					title:'减：特定业务预缴（征）所得税额',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_31_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					groud:'32',
					title:'本期应补（退）所得税额（27-28-29-30-31） \\ 税务机关确定的本期应纳所得税额',
					disabledsdsA_1_x_1:false,
					sdsA_1_x_2: {
						cellCode:"sdsA_1_32_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},

			],
		headDatas: [
			{
				title: "代码",
				width: '100px',
				prop: "code",
				custom: true,
			}, {
				title: "附报事项名称",
				prop: "title",
				custom: true,
				width: "225px"
			}, {
				title: "金额或选项",
				prop: "title2",
				custom: true,
				width: "225px"
			}, {
				title: "金额或选项",
				prop: "sdsA_1_x_3",
				width: '200px',
				custom: true,
			},
			],
			tableDatas:[
				{
					hanh: "0c",
					code:"K01001",
					title: "扶贫捐赠支持全额扣除",
					sdsA_1_x_3: {
						cellCode:"sdsA_1_0c_2",
						cellType:"1",
						cellVal:"0"
					}
				},
				{
					hanh: "0d",
					code:"Y01001",
					title: "软件集成电路企业优惠政策适用类型",
					sdsA_1_x_3: {
						cellCode:"sdsA_1_0d_2",
						cellType:"1",
						cellVal:"0"
					}
				},
				{
					hanh: "0e",
					code:"K01002",
					title: "职工薪酬",
					title2: "已计入成本费用的职工薪酬（单位：元）",
					sdsA_1_x_3: {
						cellCode:"sdsA_1_0e_3",
						cellType:"1",
						cellVal:"0"
					}
				},
				{
					hanh: "0f",
					code:"K01002",
					title: "职工薪酬",
					title2: "实际支付给职工的应付职工薪酬（单位：元）",
					sdsA_1_x_3: {
						cellCode:"sdsA_1_0f_3",
						cellType:"1",
						cellVal:"0"
					}
				},
				{
					hanh: "0g",
					code:"Y01002",
					title: "出口方式",
					sdsA_1_x_3: {
						cellCode:"sdsA_1_0g_1",
						cellType:"1",
						cellVal:"N,N,N",
						cellVal1:"N",
						cellVal2:"N",
						cellVal3:"N"
					}
				},
				{
					hanh: "0h",
					code:"Y01003",
					title: "资产损失",
					sdsA_1_x_3: {
						cellCode:"sdsA_1_0h_1",
						cellType:"1",
						cellVal:"0"
					}
				},
			],
			headData: [
				{
					title: "优惠及附报事项有关信息",
					children:[{
						title: "项目",
						prop: "title",
						custom: true,
					},{
						title: "一季度",
						children:[{
							title: "季初",
							prop: "sdsA_1_x_1",
							
							custom: true,
						},
						{
							title: "季末",
							
							prop: "sdsA_1_x_2",
							custom: true,
						}]
						
					},{
						title: "二季度",
						children:[{
							title: "季初",
							prop: "sdsA_1_x_3",
							
							custom: true,
						},
						{
							title: "季末",
							prop: "sdsA_1_x_4",
							
							custom: true,
						}]
						
					},{
						title: "三季度",
						children:[{
							title: "季初",
							prop: "sdsA_1_x_5",
							
							custom: true,
						},
						{
							title: "季末",
							prop: "sdsA_1_x_6",
							
							custom: true,
						}]
						
					},{
						title: "四季度",
						children:[{
							title: "季初",
							prop: "sdsA_1_x_7",
							
							custom: true,
						},
						{
							title: "季末",
							prop: "sdsA_1_x_8",
							
							custom: true,
						}]
					},{
						title: "季度平均值",
						prop: "sdsA_1_x_9",
							
							custom: true,
					}]
					
				},
				
			],
			tableData: [{
					title: "从业人数",
					disabledsdsA_1_x_1:false,
					disabledsdsA_1_x_2:false,
					disabledsdsA_1_x_3:false,
					disabledsdsA_1_x_4:false,
					disabledsdsA_1_x_5:false,
					disabledsdsA_1_x_6:false,
					disabledsdsA_1_x_7:false,
					disabledsdsA_1_x_8:false,
					disabledsdsA_1_x_9:true,
					sdsA_1_x_1: {
						cellCode:"sdsA_1_1_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_2: {
						cellCode:"sdsA_1_1_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_3: {
						cellCode:"sdsA_1_1_3",
						cellType:"1",
						cellVal:"240040043.8"
					},
					sdsA_1_x_4: {
						cellCode:"sdsA_1_1_4",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_5: {
						cellCode:"sdsA_1_1_5",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_6: {
						cellCode:"sdsA_1_1_6",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_7: {
						cellCode:"sdsA_1_1_7",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_8: {
						cellCode:"sdsA_1_1_8",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_9: {
						cellCode:"sdsA_1_1_9",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					title: "资产总额（万元）",
					disabledsdsA_1_x_1:false,
					disabledsdsA_1_x_2:false,
					disabledsdsA_1_x_3:false,
					disabledsdsA_1_x_4:false,
					disabledsdsA_1_x_5:false,
					disabledsdsA_1_x_6:false,
					disabledsdsA_1_x_7:false,
					disabledsdsA_1_x_8:false,
					disabledsdsA_1_x_9:true,
					sdsA_1_x_1: {
						cellCode:"sdsA_1_2_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_2: {
						cellCode:"sdsA_1_2_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_3: {
						cellCode:"sdsA_1_2_3",
						cellType:"1",
						cellVal:"240040043.8"
					},
					sdsA_1_x_4: {
						cellCode:"sdsA_1_2_4",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_5: {
						cellCode:"sdsA_1_2_5",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_6: {
						cellCode:"sdsA_1_2_6",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_7: {
						cellCode:"sdsA_1_2_7",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_8: {
						cellCode:"sdsA_1_2_8",
						cellType:"1",
						cellVal:"240040043.08"
					},
					sdsA_1_x_9: {
						cellCode:"sdsA_1_2_9",
						cellType:"1",
						cellVal:"240040043.08"
					},
				}
			]
		
	}
	return obj
}
